import React from 'react'
import {Col, Row} from './Display'
import info from '../assets/info.svg'
import i18n from 'i18n'

type NextStepsProps = {
  solutionsCount: number
}

export default function NextSteps(props: NextStepsProps) {
  return (
    <Row className="w-full justify-between px-4 py-3 mb-6 bg-gray-itx-border rounded-md">
      <Col>
        <Row>
          <div className="text-itx-gray-dark text-xs font-bold">{i18n.t('solutions.nextStep')}</div>
        </Row>
        <Row>
          <div className="text-itx-gray-dark text-base font-bold">
            {props.solutionsCount === 0 ? i18n.t('solutions.exploreSolutions') : i18n.t('solutions.startProject')}
          </div>
        </Row>
      </Col>
      <Row>
        <img className={`w-full`} alt={'info'} src={info} />
      </Row>
    </Row>
  )
}
